<template>
  <div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`biztositott_nev_${listName}_${pKey}`"
        >Név <span v-if="selected" class="text-danger">*</span></label
      >
      <ValidationProvider
        rules="required"
        :name="`biztositott_nev_${listName}_${pKey}`"
        v-slot="{ errors, classes }"
        class="col-sm-8"
        v-if="selected"
      >
        <input
          class="form-control"
          type="text"
          v-model="name"
          :id="`biztositott_nev_${listName}_${pKey}`"
          :class="{ classes, 'dark-border': true }"
          required
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
      <div class="col-sm-8" v-else>
        {{ name }}
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`biztositott_nev_${listName}_${pKey}`"
        >Születési dátum
        <span v-if="selected" class="text-danger">*</span></label
      >
      <div class="col-sm-8" v-if="selected">
        <input
          :id="`biztositott_nev_${listName}_${pKey}`"
          class="form-control dark-border"
          type="date"
          :min="birthMinDate"
          :max="birthMaxDate"
          v-model="bornDate"
          required
        />
        <!-- <Datepicker
          class="dark-border"
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="disabledDates"
          :typeable="true"
          v-model="bornDate"
          :bootstrap-styling="true"
          :required="true"
        ></Datepicker> -->
        <ValidationProvider
          :immediate="true"
          :rules="bornDateRules"
          :name="`biztositott_szul_${listName}_${pKey}`"
          v-slot="{ errors }"
        >
          <input v-show="false" type="text" :value="bornDate" disabled />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="col-sm-8" v-else>
        {{ new Date(bornDate).toLocaleDateString("hu-HU") }}
      </div>
    </div>
    <div class="form-group row" v-if="selected">
      <label class="col-sm-4">
        Biztosított törlése<br />
        <span class="text-danger fw-normal"
          >A törléssel a beírt adatok elvesznek.</span
        >
      </label>
      <div class="col-sm-8">
        <button
          type="button"
          class="btn btn-red w-100"
          @click="deleteInsuredPerson"
        >
          Törlés
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { hu } from "vuejs-datepicker/dist/locale";
import moment from "moment";

export default {
  props: ["pKey", "person", "selected", "listName"],
  components: {
    Datepicker,
  },
  data() {
    const today = moment();

    let maxAge = 70;

    if (this.listName === "temetes") {
      maxAge = 65;
    }

    if (this.listName === "utasbiztositas") {
      maxAge = 70;
    }

    const minDate = moment().subtract(maxAge, "years");

    return {
      hu: hu,

      birthMinDate: minDate.format("YYYY-MM-DD"),
      birthMaxDate: today.format("YYYY-MM-DD"),

      disabledDates: {
        customPredictor: function(date) {
          const currentDate = moment(date);

          return (
            currentDate.isBefore(minDate, "day") ||
            currentDate.isAfter(today, "day")
          );
        },
      },
    };
  },
  computed: {
    name: {
      get() {
        return this.$store.state.chosenAccessories[this.listName].biztositottak[
          this.pKey
        ].name;
      },
      set(value) {
        this.$store.commit("updateInsuredPerson", {
          index: this.pKey,
          key: "name",
          value: value,
          listName: this.listName,
        });
      },
    },
    bornDate: {
      get() {
        return this.$store.state.chosenAccessories[this.listName].biztositottak[
          this.pKey
        ].bornDate;
      },
      set(value) {
        this.$store.commit("updateInsuredPerson", {
          index: this.pKey,
          key: "bornDate",
          value: value,
          listName: this.listName,
        });
      },
    },
    formattedBornDate: {
      get() {
        if (!this.bornDate) return;
        const date = new Date(
          new Date(this.bornDate).getFullYear(),
          new Date(this.bornDate).getMonth(),
          new Date(this.bornDate).getDate() + 1,
        )
          .toISOString()
          .split("T")[0];
        // console.log("formatted borndate: " + date);
        return date;
      },
    },
    bornDateRules() {
      if (this.listName === "utasbiztositas") {
        // console.log("utas born date rules")
        return "required|utas_szuletes_datum";
      } else if (this.listName === "temetes") {
        return "required|temetes_szuletes_datum";
      } else {
        return;
      }
    },
  },
  methods: {
    deleteInsuredPerson() {
      if (!this.selected) return;
      this.$store.commit("deleteInsuredPerson", {
        id: this.pKey,
        listName: this.listName,
      });
    },
  },
};
</script>
